import { SectionHeaderBarActions } from '../../../../../../common/components/SectionHeaderBarActions';
import { FilterApplicationsDropDownBox } from './components/FilterApplicationsDropDownBox';
import { ExportApplicationsButton } from './components/ExportApplicationsButton';
import { BridgeAppraisalStatusGroupSection } from '../ApplicationsGrid/functions/mappers/bridgeAppraisalStatusGroupMapper';
import { ModalDemo } from '../../../modalDemo/modalDemo';
export interface HeaderBarActionsProps {
    selectedGroup?: BridgeAppraisalStatusGroupSection | 'All';
    set_selectedGroup: (value: BridgeAppraisalStatusGroupSection | 'All') => void;
}

export const HeaderBarActions: React.FC<HeaderBarActionsProps> = ({ selectedGroup, set_selectedGroup }) => {
    return (
        <SectionHeaderBarActions>
            <div style={{ marginRight: 'auto' }}>
                <FilterApplicationsDropDownBox
                    selectedGroup={selectedGroup}
                    set_selectedGroup={set_selectedGroup}
                />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <ModalDemo /> {/* TEMP: StandardModal test */}
                <ExportApplicationsButton selectedGroup={selectedGroup} />
            </div>
        </SectionHeaderBarActions>
    );
};
